export const COLUMNS = [
  { name: '#', uid: 'id' },
  { name: 'Fecha solicitud', uid: 'created_at' },
  { name: 'Categoría', uid: 'sbu' },
  { name: 'Marca', uid: 'brand' },
  { name: 'Modelo', uid: 'model' },
  { name: 'Capacidad', uid: 'capacity' },
  { name: 'Solicitante', uid: 'user_name' },
  { name: 'Email solicitante', uid: 'user_email' },
  { name: 'Tienda solicitante', uid: 'store_name' }
]

// Mismos tamaños que ofrece el listado principal.
export const PAGE_SIZES = [10, 25, 50, 100]

export const DEFAULT_PAGE_SIZE = 10

// Techo del backend (MAX_PAGE_SIZE en getDeviceRequests).
export const MAX_PAGE_SIZE = 100

export const EXCEL_NAME = 'Dispositivos_solicitados'
